import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { routes } from '@platform/core/lib/routes';
import type { IBiModulesTableProps } from './IBiModulesTableProps';

/**
 * Таблиця «Модулі» огляду робочого простору (прототип v4 G:L1712): Модуль · Разом · Відкрито (синій) · Прострочено (помаранчевий, якщо є)
 * · Виконано (смуга 8px і відсоток); рядок відкриває модуль; власна горизонтальна прокрутка від 560px.
 */
export function BiModulesTable({ rows }: IBiModulesTableProps) {
  const { t } = useTranslation();
  return (
    <section className="bi-card" aria-label={t('biPage.modules')}>
      <div className="bi-card__title">{t('biPage.modules')}</div>
      <div className="bi-scroll">
        <div className="bi-table">
          <div className="bi-trow bi-thead">
            <span>{t('biPage.colModule')}</span><span>{t('biPage.colTotal')}</span><span>{t('biPage.colOpen')}</span><span>{t('biPage.colOverdue')}</span><span>{t('biPage.colDone')}</span>
          </div>
          {rows.map((r) => (
            <Link key={r.key} className="bi-trow" to={routes.module(r.key)}>
              <span className="bi-tname">{r.name}</span>
              <span className="bi-num">{r.total}</span>
              <span className="bi-num bi-open">{r.open}</span>
              <span className="bi-num" style={{ color: r.overdue ? 'var(--bi-orange)' : 'var(--muted)' }}>{r.overdue}</span>
              <span className="bi-done"><span className="bi-done__track"><span className="bi-done__fill" style={{ width: `${r.donePct}%` }} /></span><span className="bi-done__pct">{r.donePct}%</span></span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
